
import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, HostListener, Inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';
import { TranslateService } from '@ngx-translate/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { AccountService } from 'app/guards/account.service';
import { Car } from 'app/models/car.model';
import { DriverProcess, DriverProcessDetail, DriverProcessDetailEnum } from 'app/models/driverProcess.model';
import { Poligon, PoligonDetail } from 'app/models/poligon.model';
import { Shift, ShiftContainerRequest } from 'app/models/shift.model';
import { CarService } from 'app/services/car.service';
import { ContainerService } from 'app/services/container.service';
import { DriverProcessService } from 'app/services/driver-process.service';
import { PoligonService } from 'app/services/poligon.service';
import { ShiftService } from 'app/services/shift.service';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import * as L from 'leaflet';
import 'leaflet-draw';
import 'leaflet.fullscreen';
import 'leaflet-routing-machine';
import { NgxSpinnerService } from 'ngx-spinner';
import { isNullOrUndefined } from 'util';
import { DriverFinishConfirmationComponent } from '../driver-finish-confirmation/driver-finish-confirmation.component';
import { Container } from 'app/models/container.model';
import { SetGeneralZone } from 'app/models/set-general-zone.model';
import { ReportingService } from 'app/services/reporting.service';

//#region Icon

const iconUrl = 'assets/img/marker-icon.png';
const iconDefault = L.icon({
    iconUrl,
    iconSize: [30, 30],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28]
});

const ContainerIcon = L.Icon.extend({
    options: {
        iconSize: [25, 25],
        iconAnchor: [5, 20],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28]
    }
})

const LeafIcon = L.Icon.extend({
    options: {
        iconSize: [40, 40], //30,30
        iconAnchor: [5, 5], //12,41
        popupAnchor: [15, 0],//1,34
        tooltipAnchor: [16, -28],
        shadowAnchor: [4, 62]
    }
});


L.Marker.prototype.options.icon = iconDefault;
export class ContainerMarker {
    marker?: any
    container_id?: any
}

//#endregion

@Component({
    selector: 'app-driver-map',
    templateUrl: './driver-map.component.html',
    styleUrls: ['./driver-map.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    providers: [PoligonService]
})

export class DriverMapComponent implements AfterViewInit {

    @ViewChild('finishBtn') finishBtn: ElementRef;
    capitals: string = '/assets/data/usa-capitals.geojson';

    public startRouting = true // true ise gidiş rotalama aktif
    public finishRouting = false; // true ise dönüş rotalama aktif
    public finishEndControl = true; // false ise rotalama bitti
    public routingContainer:Array<Container> =[];
    public garbageCenter:Container;
    public watchId: any;
    public polygon: Poligon;
    public tempMyLocation?: L.LatLng;
    public totalDistance:number = 0;
    public totalDuration:number = 0;
    public totalContainer:number = 0;
    public totalEmptyContainer:number = 0;
    public totalFullContainer:number = 0;
    public driverProcess: DriverProcess = {};
    public selectedShift: number;
    public shiftControl = false;
    public containerMarkers?: Array<ContainerMarker> = []
    public shiftList: Array<Shift> = [];
    public message: string;
    public shift: Array<ShiftContainerRequest> = [];
    private map;
    private watchTimer = 0;
    public processDetailHistory: Array<DriverProcessDetail> = [];
    public start: any
    public finish: any
    public destinations: any[]
    public myLocation: L.LatLng = L.latLng(0, 0);
    public car: Car
    private _containers: Array<PoligonDetail> = [];
    public map_car_icon = new LeafIcon({ iconUrl: 'assets/img/garbage-truck.png' });
    public car_marker = L.marker([0, 0], { icon: this.map_car_icon });

    public options = {
        enableHighAccuracy: true,
        timeout: this.appConfigService.apiConfig["watch-timeout"],
        maximumAge: this.appConfigService.apiConfig["watch-age"]
    };
    constructor(
        private _toastService: ToasterService,
        private _containerService: ContainerService,
        private _carService: CarService,
        private _shiftService: ShiftService,
        private _dialog: MatDialog,
        private _spinner: NgxSpinnerService,
        private _reportingService:ReportingService,
        private accountService: AccountService,
        private _polygonService: PoligonService,
        private _driverProcessService: DriverProcessService,
        private appConfigService: AppInitializationService,
        private _translateService: TranslateService,
        private _http: HttpClient,
        private elementRef: ElementRef,
        @Inject(DOCUMENT) document: Document
    ) {
        this.getCarPolygon();
        if (isNullOrUndefined(this.car)) {
            this.car = new Car();
            this.car.plate = this._translateService.instant("UNDEFINED_USER");
        }        
        var isShift = this.appConfigService.apiConfig["isShift"]
        if (!isShift) {
            var shiftId = localStorage.getItem("shiftId")
            this.shiftControl = true;
            this.selectedShift = null;
            this.setMap();
        }
        else {
            if (shiftId && shiftId != "-1") {
                this.shiftControl = true;
                this.selectedShift = parseInt(shiftId);
                this.setMap();
            }
        }
    }

    public get MapTileUrl(): string {
        return 'http://tile.openstreetmap.org/{z}/{x}/{y}.png';
    }
    public async getCarPolygon(){
        await this.getByCar();
        await this.getByPolygon();
    }

    public async getByCar(){
        try {
            this.car = await this._carService.getByCarImei(localStorage.getItem("IMEI"));
        } catch (error) {
            console.warn(error);
            this._spinner.hide('routing');
        }
    }

    public async getByPolygon(){
        try {
            this.polygon = await this._polygonService.getByPoligon(this.car.polygonId);
        } catch (error) {
            console.warn(error);
            this._spinner.hide('routing');
        }
    }

    private async initMap(): Promise<void> {

        this.map = L.map('map', {
            center: [39.09766, 34.56039],
            zoom: 19
        });
        L.control.fullscreen().addTo(this.map);
        
        this.map.toggleFullscreen();
       
        await this.mySetLocation(this.map);

        const tiles = L.tileLayer(
            this.MapTileUrl, {
            maxZoom: 19,
            minZoom: 5,
            attribution: 'AKILLI-ATIK-SİSTEMİ'
        });

        tiles.addTo(this.map);
    
    }

    async ngAfterViewInit(): Promise<void> {
        await this.getLocationList();
        localStorage.setItem('DistanceTraveled','0');
    }

    public async setMap() {
        this._spinner.show('routing');
        if (this.selectedShift === undefined) {
            this._toastService.toastWarning(this._translateService.instant("PLEASE_SELECT_A_SHIFT"))
            return;
        }

        this.shiftControl = true;

        try {
            localStorage.setItem("shiftId", this.selectedShift == null ? "-1" : this.selectedShift.toString())

            this.shift = await this._shiftService.getByShift(this.selectedShift);
        } catch (error) {
            this._spinner.hide('routing');
            console.warn(error);

        }
        await this.initMap();
        setTimeout(async () => {
            this.mySetLocation(this.map)
            await this.makeCapitalMarkers(this.map);
            await this.updateRoutingForRoute();
            this.locationConfigsSet();
            await this.SetDriverProcess();
            this._spinner.hide('routing');
        }, 2000);
    }

    public async SetDriverProcess() {
        var dp = localStorage.getItem("driverProcess");
        if (dp) {
            try {
                this.driverProcess = await this._driverProcessService.getDriverProcessControl(dp);
                if (this.driverProcess) {
                    this.processDetailHistory = await this._driverProcessService.getDriverProcessDetail(this.driverProcess.id)
                }
            } catch (error) {
                console.warn(error);
                this._spinner.hide('routing');
            }
        }
        else {
            try {
                this.driverProcess.carId = this.car.id;
                this.driverProcess.sessionLogId = parseInt(localStorage.getItem('SessionLogId'))
                this.driverProcess.polygonId = this.car.poligon.id;
                this.driverProcess.startLat = this.myLocation.lat;
                this.driverProcess.startLng = this.myLocation.lng;
                this.driverProcess.estimatedDistance = this.totalDistance.toString();
                this.driverProcess.estimatedTime = this.totalDuration.toString();
                this.driverProcess.allContainerCount = this.totalContainer;
                this.driverProcess.fullContainerCount = this.totalFullContainer;
                this.driverProcess.emptyContainerCount = this.totalEmptyContainer;
                this.driverProcess.companyId = this.car.companyId;
                this.driverProcess.startDate = (new Date);
                this.driverProcess.endDate = null;
                this.driverProcess.shiftId = this.selectedShift;
                this.driverProcess.status = true;
                this.driverProcess = await this._driverProcessService.add(this.driverProcess);
                localStorage.setItem("driverProcess", this.driverProcess.id.toString())
            } catch (error) {
                console.warn(error);
                this._spinner.hide('routing');
            }
        }
        this.elementRef.nativeElement.querySelector('.finishBtn').style.display = "inline";
    }

    public locationConfigsSet() {

        if (this.finishEndControl) {
            this.updateRoutingForCar();
            this.updateRoutingForRoute();
            this.mySetLocationCar();

        }

    }

    async onFinishControlClick() {
        const _dialog = this._dialog.open(DriverFinishConfirmationComponent, {
            disableClose: false
        })
        if(this.map._isFullscreen){
            this.map.toggleFullscreen();
        }
        _dialog.componentInstance.added.subscribe(async (mdoel: any) => {
            if (this.shift.length != 0) {
                this.shift[0].shift.complated = true;
                this._shiftService.updatedSingle(this.shift[0].shift)
            }
            this.driverProcess.endDate = new Date;
            this.driverProcess.endLat = this.myLocation.lat.toString();
            this.driverProcess.endLng = this.myLocation.lng.toString();
            var distanceTraveled = parseInt(localStorage.getItem('DistanceTraveled'));
 
            this.driverProcess.distanceTraveled = distanceTraveled;
            await this._driverProcessService.updated(this.driverProcess);
            await this.setGeneralZoneReport();
            this._toastService.toastSuccess()
            localStorage.removeItem("driverProcess");
            _dialog.close();
            this.accountService.logout();
        })
    }

    async setGeneralZoneReport(){
        var setGeneralZone = new SetGeneralZone();
        setGeneralZone.containers = this.routingContainer;
        setGeneralZone.garbageCenter = this.garbageCenter;
        setGeneralZone.driverProcess = this.driverProcess;
        setGeneralZone.polygon = this.polygon;
        setGeneralZone.companyId = parseInt(localStorage.getItem("CompanyID"));
        setGeneralZone.car = this.car;
        setGeneralZone.myLocationLat = this.myLocation.lat.toString();
        setGeneralZone.myLocationLng = this.myLocation.lng.toString();
        await this._reportingService.setGeneralZoneReport(setGeneralZone);
    }

    getPosition(map: L.map): Promise<any> {

        return new Promise((resolve, reject) => {

            if (navigator.geolocation) {

                this.watchId = navigator.geolocation.watchPosition(position => {

                    this.myLocation = new L.LatLng(position.coords.latitude, position.coords.longitude);
                    this.message = this.myLocation;
                    if(this.tempMyLocation){
                        var fromLatLng = this.tempMyLocation;
                        var toLatLng = this.myLocation;
                        var dis = fromLatLng.distanceTo(toLatLng);
                        var distanceTraveled = parseInt(localStorage.getItem('DistanceTraveled'));
                        localStorage.setItem('DistanceTraveled',(dis + distanceTraveled).toString());
                    }

                    this.tempMyLocation = this.myLocation;

                    resolve({ lng: position.coords.longitude, lat: position.coords.latitude });

                    if (this.watchTimer > this.appConfigService.apiConfig["watch-index"]) {
                        this.map.setView(new L.LatLng(position.coords.latitude, position.coords.longitude),19) 
                        this.locationConfigsSet();
                        this.watchTimer = 0;
                    }
                    else {
                        this.watchTimer++;
                    }

                },
                    err => {
                        console.log(err);
                        this._spinner.hide('routing');
                        this.message += err.code
                    },
                    this.options
                );
            }

        });

    }

    updateRoutingForCar() { // araba her hangi bir konteynere yaklaştığı zaman rota eleniyor
        var startWaypoints = this.start.options.plan._waypoints;
        startWaypoints = startWaypoints.filter(x => x.latLng != undefined); // Rota bitiminde planın 2. değeri undefined

        const waypointslist: L.LatLng[] = [];
        waypointslist.push(new L.LatLng(this.start.options.plan._waypoints[0].latLng.lat, this.start.options.plan._waypoints[0].latLng.lng)) // gidiş rotasının kendi konumu belirle

        var finishWaypoints = this.finish.options.plan._waypoints;
        finishWaypoints = finishWaypoints.filter(x => x.latLng != undefined); // Rota bitiminde planın 2. değeri undefined

        const waypointsFinish: L.LatLng[] = [];
        waypointsFinish.push(new L.LatLng(this.finish.options.plan._waypoints[0].latLng.lat, this.finish.options.plan._waypoints[0].latLng.lng)) // dönüş rotasının kendi konumu belirle
        if (startWaypoints.length > 1) {
            for (let i = 1; i < startWaypoints.length; i++) { // 0 kendi konumu olduğu için hesaplanması istenmemekte

                if (this.myLocation.distanceTo(this.start.options.plan._waypoints[i].latLng) > 10) {
                    waypointslist.push(new L.LatLng(this.start.options.plan._waypoints[i].latLng.lat, this.start.options.plan._waypoints[i].latLng.lng))
                }
                else {
                    try {
                        var containerfind = this._containers.find(x =>
                            x.container.latitude == this.start.options.plan._waypoints[i].latLng.lat.toString()
                        )
                        // var dpdetail = new DriverProcessDetail;
                        // dpdetail.driverProcessId = this.driverProcess.id;
                        // dpdetail.visitDate = new Date;
                        // dpdetail.containerId = containerfind.container.id;
                        // this._driverProcessService.addDetail(dpdetail)

                    } catch (error) {
                        console.warn(error);
                        this._spinner.hide('routing');
                    }
                }
            }
            this.start.setWaypoints(waypointslist);

            return;
        }
        else if (startWaypoints.length <= 1 && !this.finishRouting) {
            this.startRouting = false
            this.finishRouting = true
            return;
        }

        if (this.finishRouting && finishWaypoints.length > 1) {

            for (let j = 1; j < finishWaypoints.length; j++) {// 0 kendi konumu olduğu için hesaplanması istenmemekte

                if (this.myLocation.distanceTo(this.finish.options.plan._waypoints[j].latLng) > 10) {

                    waypointsFinish.push(new L.LatLng(this.finish.options.plan._waypoints[j].latLng.lat, this.finish.options.plan._waypoints[j].latLng.lng))

                }
                else {
                    try {
                        var containerfind = this._containers.find(x =>
                            x.container.latitude == this.start.options.plan._waypoints[j].latLng.lat.toString()
                        )
                        // var dpdetail = new DriverProcessDetail;
                        // dpdetail.driverProcessId = this.driverProcess.id;
                        // dpdetail.visitDate = new Date;
                        // dpdetail.containerId = containerfind.container.id;
                        // this._driverProcessService.addDetail(dpdetail)

                    } catch (error) {
                        console.warn(error);
                        this._spinner.hide('routing');
                    }
                }
            }

            this.finish.setWaypoints(waypointsFinish);
        }
        else if (this.finishRouting && finishWaypoints.length <= 1) {
            this.finishEndControl = false
            try {
                // this.shift[0].shift.complated = true;
                // this._shiftService.updatedSingle(this.shift[0].shift)

                // this.driverProcess.endDate = new Date;
                // this.driverProcess.status = false;
                // this._driverProcessService.updated(this.driverProcess);

            } catch (error) {
                console.warn(error);
                this._spinner.hide('routing');
            }
            this._toastService.toastSuccess(this._translateService.instant("THE_PROCESS_IS_COMPLETED"))
        }

    }

    async updateRoutingForRoute() { // arabanın güncellenene konumuna göre rota güncelleniyor 
        this.map.removeLayer(this.car_marker)
        this.car_marker = L.marker([this.myLocation.lat, this.myLocation.lng], { icon: this.map_car_icon });
        this.car_marker.addTo(this.map);

        var car_marker_location = this.car_marker.getLatLng();

        this.map.panTo(new L.LatLng(car_marker_location.lat, car_marker_location.lng))

        if (this.startRouting && !isNullOrUndefined(this.start.options.plan._waypoints[1].latLng)) {
            const waypointslist: L.LatLng[] = [];
            var LatLngList = this.start.options.plan._waypoints;

            waypointslist.push(new L.LatLng(this.myLocation.lat, this.myLocation.lng))  //waypointlistin 0. elemanı her zaman arabanın konumu 
            for (let x = 1; x < LatLngList.length; x++) {

                waypointslist.push(new L.LatLng(LatLngList[x].latLng.lat, LatLngList[x].latLng.lng))

            }
            this.start.setWaypoints(waypointslist);

        }

        //  gidiş rotalama işlemi bittiktan sonra dönüş rotlama işlemi için
        if (this.finishRouting && this.finishEndControl && !isNullOrUndefined(this.finish.options.plan._waypoints[1].latLng)) {

            const waypointsFinish: L.LatLng[] = [];
            var LatLngList = this.finish.options.plan._waypoints;

            waypointsFinish.push(new L.LatLng(this.myLocation.lat, this.myLocation.lng))

            for (let x = 1; x < LatLngList.length; x++) {

                waypointsFinish.push(new L.LatLng(LatLngList[x].latLng.lat, LatLngList[x].latLng.lng))

            }
            this.finish.setWaypoints(waypointsFinish);

        }
    }


    async mySetLocationCar() {
        this.car.eLatitude = this.myLocation.lat;
        this.car.eLongitude = this.myLocation.lng;
        if (this.car.id == undefined) {
            return;
        }
        this._carService.updated(this.car)
    }

    async mySetLocation(map: L.map) {

        try {

            let position = await this.getPosition(map);

            this.myLocation = new L.LatLng(position.lat, position.lng);

        } catch (error) {
            console.warn(error);
            this._spinner.hide('routing');
        }
    }

    private async getLocationList() {
        try {
            this._containers = await this._containerService.getByPolygonsContainer(localStorage.getItem("IMEI"));

            var _shifts = await this._shiftService.getByCarImei(localStorage.getItem("IMEI"));
            _shifts = _shifts.filter(x =>
                new Date(x.startDate) < new Date() && new Date(x.endDate) > new Date && x.complated != true
            )
            this.shiftList = _shifts

            //this.shiftList = await this._shiftService.getByCar(localStorage.getItem("Username"));
        } catch (error) {
            this._spinner.hide('routing');
            console.warn(error);
            return [];
        }
    }

    public driverProcessHistoryControl() {
        this.processDetailHistory.forEach(y => {
            var index = this._containers.findIndex(x => x.discriminatorId == y.containerId)
            if (index != -1) {
                this._containers.splice(index, 1);
            }
        })
    }

    async makeCapitalMarkers(map: L.map): Promise<void> {
        const coordinates: L.LatLng[] = [];
        var finishCoordinates: L.LatLng;
        coordinates.push(L.latLng(this.myLocation)); // 0 kendi konumu
        this.shift.forEach(sh => {
            var control = this._containers.find(cd => cd.discriminatorId == sh.container.id && cd.container.containerType != true);
            if (control == undefined) {
                var poligonDetail = new PoligonDetail();
                poligonDetail.container = sh.container;
                poligonDetail.discriminatorId = sh.container.id;
                poligonDetail.discriminator = "container";

                var index = this.processDetailHistory.findIndex(x => x.containerId == sh.container.id)
                if (index == -1) {
                    coordinates.push(L.latLng(sh.container.latitude, sh.container.longitude))
                }
                this._containers.push(poligonDetail);
            }
        })
        if (this.processDetailHistory.length != 0) {
            this.driverProcessHistoryControl();
        }
        this._containers.forEach(x => {

            if (x.container.latitude && x.container.longitude) {
                if (x.container.containerType == true) {
                    const marker = L.marker([x.container.latitude, x.container.longitude], { icon: new ContainerIcon({ iconUrl: 'assets/img/end.png' }) });
                    marker.bindPopup(function () {
                        let html = `<div> Tanım : ${x.container.streetDesc}</div>`;
                        return html;
                    });
                    marker.addTo(map)
                    finishCoordinates = new L.latLng(x.container.latitude, x.container.longitude)
                    this.routingContainer.push(x.container)
                    this.garbageCenter=x.container;
                    return;
                }
                else {
                    this.totalContainer++;
                    var calc = 0;
                    if (x.container.device.deviceLatestStatus) {
                        calc = (((parseInt(x.container.altitude) - parseInt(x.container.deadZone)) -
                            (parseInt(x.container.device.deviceLatestStatus.mesafe) - parseInt(x.container.deadZone))) * 100) / (parseInt(x.container.altitude) - parseInt(x.container.deadZone));
                        if (calc < 0) {
                            calc = 0
                        }
                        else if (calc > 100) {
                            calc = 100
                        }
                        var calculate = x.container.device.deviceLatestStatus ? calc : -1;
                        var map_icon;

                        if (calculate <= this.appConfigService.apiConfig["container-msf-yellow"]) {
                            map_icon = new ContainerIcon({ iconUrl: 'assets/img/trash-green.png' });
                        }
                        else if (calculate <= this.appConfigService.apiConfig["container-msf-orange"]) {
                            map_icon = new ContainerIcon({ iconUrl: 'assets/img/trash-yellow.png' });
                        }
                        else if (calculate <= this.appConfigService.apiConfig["container-msf-red"]) {
                            map_icon = new ContainerIcon({ iconUrl: 'assets/img/trash-orange.png' })
                        }
                        else {
                            map_icon = new ContainerIcon({ iconUrl: 'assets/img/trash-red.png' })
                        }

                        if (calc > this.polygon.treshold) {
                            this.totalFullContainer++;
                            const marker = new L.marker([x.container.latitude, x.container.longitude], { icon: map_icon });
                            var fullnessValue = calculate == -1 ? this._translateService.instant("UNDEFINED_VALUE") : calculate.toString().slice(0, 4);
                            const _this = this;
                            marker.bindPopup(this.makeCapitalPopup(
                                x.container.latitude + "/" + x.container.longitude,
                                x.container.street,
                                x.container.streetDesc,
                                fullnessValue,
                                x.discriminatorId,
                                x.container.name), { closeOnClick: false, className: "containerPopup", autoClose: false })
                                .on("popupopen", async () => {
                                    var str = ".containerCheck-" + x.discriminatorId;
                                    await _this.elementRef.nativeElement
                                        .querySelector(str)
                                        .addEventListener("click", async (e: any) => {
                                            _this.onContainerCheck(e.target);
                                        });
                                })
                            marker.addTo(map)
                            var containerMarker = new ContainerMarker();
                            containerMarker.marker = marker;
                            containerMarker.container_id = x.discriminatorId;
                            this.containerMarkers.push(containerMarker)
                            if (calculate > this.polygon.treshold) {
                                coordinates.push(L.latLng(x.container.latitude, x.container.longitude))
                                this.routingContainer.push(x.container);
                            }
                        }
                        else{
                            this.totalEmptyContainer++;
                        }
                    }

                }
            }
        });
        coordinates.push(finishCoordinates)
        this.destinations = (await this.TSPCalculator(coordinates)).map(s => s.LatLng); //rota planı belirle
        this.start = L.Routing.control({//gidiş rotası
            waypoints: coordinates,    // coordinates in 0. konumu kendi konumumuz aynı zamanda waypointsin 0. sıda 
            lineOptions: {
                styles: [{ color: 'blue', opacity: 0.6, weight: 5 }]
            },
            plan: L.Routing.plan(
                this.destinations,
                {
                    createMarker: function () {
                        return null;
                    }
                }
            ),
            //serviceUrl: 'http://router.project-osrm.org/route/v1',
            serviceUrl: this.appConfigService.apiConfig["routing-url"], //'http://127.0.0.1:5000/route/v1',
            addWaypoints: false,
            autoRoute: true,
            fitSelectedRoutes: false,
            routeWhileDragging: false,
            draggableWaypoints: false,
            showAlternatives: false,
            createMarker: function () { return null; },
            show: false
        }).addTo(map);


        let destinationsback = this.destinations.reverse();
        this.finish = L.Routing.control({//dönüş rotası çp merkezine
            waypoints: [destinationsback[0], finishCoordinates ? finishCoordinates : L.latLng(this.myLocation)],// en son konumdan çöp toplanma merkezine
            plan: L.Routing.plan(
                [destinationsback[0], finishCoordinates ? finishCoordinates : L.latLng(this.myLocation)],
                {
                    createMarker: function () {
                        return null;
                    }
                }
            ),
            lineOptions: {
                styles: [{ color: 'red', opacity: 0.6, weight: 2 }]
            },
            //serviceUrl: 'http://router.project-osrm.org/route/v1',
            serviceUrl: this.appConfigService.apiConfig["routing-url"], //'http://127.0.0.1:5000/route/v1',
            addWaypoints: false,
            autoRoute: true,
            fitSelectedRoutes: false,
            routeWhileDragging: false,
            draggableWaypoints: false,
            showAlternatives: false,
            createMarker: function () { return null; },
            show: false
        }).addTo(map);
        
    }

    public async TSPCalculator(coords: L.LatLng[]): Promise<Array<OrderCoord>> {
        let orderCoords = new Array<OrderCoord>();
        let calculateOrderCoords = new Array<OrderCoord>();
        let response = await this.getMatris(coords);
        let tsp = await this.postTSP(response.distances);
        let matris = response.distances;

        for (let i = 0; i < matris.length; i++) {
            let orderCoordRR = new OrderCoord();
            orderCoordRR.LatLng = new L.LatLng(response.destinations[i].location[1], response.destinations[i].location[0])
            orderCoordRR.durations = matris[i];
            calculateOrderCoords.push(orderCoordRR);
        }

        for (let a = 0; a < tsp.length - 1; a++) {
            orderCoords.push(calculateOrderCoords[tsp[a]]);
            this.totalDuration += parseInt(response.durations[tsp[a]][tsp[a+1]]);
            this.totalDistance += parseInt(response.distances[tsp[a]][tsp[a+1]]);
        }

        this._containers.filter(x=>x.discriminator!='garbage-center').forEach(y => {
            this.totalDuration += y.container.collectionTime;
        });

        return orderCoords;
    }
    postTSP(durations: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this._http.post(this.appConfigService.apiConfig["api-url"] + 'routeOptimization/getRouteOptimization', durations)
                .subscribe((response: any) => {
                    resolve(response);
                }, error => {
                    this._spinner.hide('routing')
                    reject(error)
                });
        });
    }

    getMatris(coords: L.LatLng[]): Promise<any> {
        var httpString: string = "";
        for (let x = 0; x < coords.length; x++) {
            httpString += coords[x]?.lng + "," + coords[x]?.lat;
            if (x != coords.length - 1) {
                httpString += ";"
            }
        }
        return new Promise((resolve, reject) => {
            this._http.get(this.appConfigService.apiConfig["table-url"] + httpString + "?annotations=distance,duration")
                .subscribe((response: any) => {                    
                    resolve(response);
                }, error => {
                    this._spinner.hide('routing');
                    reject(error)
                });
        });
    }

    public routingLoop(coords: L.LatLng[]): Array<OrderCoord> {
        let orderCoords = new Array<OrderCoord>();
        let calculateOrderCoords = new Array<OrderCoord>();
        let filterCoords = new Array<OrderCoord>();

        let orderCoord = new OrderCoord(); //ilk konum
        orderCoord.value = 0;
        orderCoord.LatLng = coords[0];
        orderCoords.push(orderCoord);

        let selectedCoord = coords[0];
        coords[0].op = true;


        for (var index_all = 0; index_all < coords.length; index_all++) {  //sadece döngü için 


            calculateOrderCoords = new Array<OrderCoord>();

            filterCoords = coords.filter(x => x !== selectedCoord && x.op !== true);
            for (var index_filter = 0; index_filter < filterCoords.length; index_filter++) {    //sırayla gez hesaplanan noktayı devre dışı bırak
                let coord = filterCoords[index_filter];

                let value = selectedCoord.distanceTo(coord);
                let orderCoord = new OrderCoord();
                orderCoord.value = value;
                orderCoord.LatLng = coord;
                calculateOrderCoords.push(orderCoord);
            }

            let shortestPath = calculateOrderCoords.sort((a, b) => (a.value < b.value ? -1 : 1));

            if (!isNullOrUndefined(shortestPath[0] && shortestPath[0].LatLng)) {

                orderCoords.push(shortestPath[0]); //bulduğun en kısa yolu rota listesine ekle 
                var index = coords.findIndex(function (el) {
                    return el.lat == shortestPath[0].LatLng.lat;
                });
                coords[index].op = true; //en yakını
                selectedCoord = shortestPath[0].LatLng;
            }

        }

        return orderCoords;

    }


    onContainerCheck(e) {

        try {
            var container = this._containers.find(x => x.discriminatorId == e.value) // e.path[0].value
            var containerLocation = new L.LatLng(container.container.latitude,container.container.longitude);
            var distance = containerLocation.distanceTo(this.myLocation);
            // if(distance>50)
            // {
                
            //     this._toastService.toastWarning(this._translateService.instant("CAR_CONTAINER_DISTANCE_WARNING")+(Math.ceil(distance))+"m")
            //     return;
            // }
            
            var marker = this.containerMarkers.find(x => x.container_id == e.value);  // e.path[0].value
            marker.marker.closePopup();
            marker.marker._popup = null;

            var dpdetail = new DriverProcessDetail;
            dpdetail.driverProcessId = this.driverProcess.id;
            dpdetail.visitDate = new Date; //TODO tarih 3 saat geri
            dpdetail.carLat = this.myLocation.lat.toString(); // TODO lat,lng boş geliyor.
            dpdetail.carLng = this.myLocation.lng.toString();
            dpdetail.containerId = container.discriminatorId;
            dpdetail.status = DriverProcessDetailEnum.on_hold;
            this._driverProcessService.addDetail(dpdetail)
        } catch (error) {
            console.warn(error);
        }

    }



    makeCapitalPopup(latLng: string, street: string, streetDesc, fullness: string, id?: number, name?: string): string {

        let html = `
        <div class="containerPopupStyle">
        <input class="containerCheck-${id}" type="checkbox"  id="${id}" name="${id}" value="${id}"> <label for="${id}">  ${this._translateService.instant("HAS_IT_GATHERED")}</label><br>
        </div>`
        html += "<div class=containerPopupContent>"
        html += `<div> ${this._translateService.instant("OCCUPANCY")} : % ${fullness}</div>`;
        html += `<div> ${this._translateService.instant("NAME")} : ${name}</div>`;
        //html += `<div> ${this._translateService.instant("LOCATION")}: ${latLng}</div>`;
        html += `<div> ${this._translateService.instant("TITLE")}: ${streetDesc}</div>`;
        html += `<div> ${this._translateService.instant("STREET")}: ${street}</div>`;
        html += "<div>"
        return html;
        // return html;
    }

}


export class OrderCoord {
    public LatLng?: any
    public value?: number
    public durations?: any
    public op?: boolean = false
}






